var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._b({attrs:{"input-value":_vm.campo.valor,"label":_vm.campo.label,"disabled":_vm.campo.desabilitado},on:{"change":function($event){return _vm.$emit('update', $event)}}},'v-switch',_vm.campo.propriedadesAdicionais,false))}
var staticRenderFns = []

export { render, staticRenderFns }